'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ReservationCategory } from '@eliadmin/core/src/api/reservation/reservation-api';

import { Field, type ReservationStepProps } from '../reservation-form';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ChooseService({
  form,
  services = [],
  categories = [],
  selectedCategoryId,
  setSelectedCategoryId,
}: ReservationStepProps) {
  const selectedServiceId = form.watch('reservation_service');

  return (
    <>
      <CategoryChoose
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={(id: number) => {
          setSelectedCategoryId?.(id);
          // Reset selected service when switching category, but don't immediately show "required" error.
          form.setValue('reservation_service', '', { shouldValidate: false, shouldDirty: true });
          form.clearErrors('reservation_service');
        }}
      />
      <div className="w-full rounded-[24px] bg-primary-foreground p-4 sm:p-5 lg:p-6">
        <Field
          control={form.control}
          type="custom-select-service"
          name="reservation_service"
          options={services.map(s => ({ value: s.id, label: s.name }))}
          selectedService={services.find(s => String(s.id) === String(selectedServiceId))}
          services={services}
          isDisabled={!selectedCategoryId || services.length === 0}
        />
      </div>
    </>
  );
}

function CategoryChoose({
  categories,
  selectedCategoryId,
  setSelectedCategoryId,
}: {
  categories: ReservationCategory[];
  selectedCategoryId?: number;
  setSelectedCategoryId: (categoryId: number) => void;
}) {
  return (
    <div className="grid w-full grid-cols-3 gap-2">
      {categories.map(category => {
        const isSelected = selectedCategoryId === category.id;

        return (
          <div
            key={category.id}
            onClick={() => setSelectedCategoryId(category.id)}
            className={cn(
              'ea-choose-service__radio-item',
              'col-span-1 flex w-full flex-col items-center justify-center gap-2 rounded-[24px] p-4 text-lg font-semibold tracking-tight !text-black sm:flex-row sm:justify-start sm:gap-4 md:text-xl lg:gap-6 lg:text-2xl',
              isSelected
                ? 'cursor-context-menu bg-black !text-white hover:bg-black'
                : 'cursor-pointer bg-primary-foreground text-black hover:bg-primary-foreground/75',
              'select-none transition-all duration-200',
            )}
          >
            <Image
              src={category?.image?.url ?? '/images/placeholder.png'}
              alt={resolveImageAlt(category?.image, category?.name)}
              width={48}
              height={48}
              className="rounded-[6px] object-cover object-center sm:rounded-[9px]"
            />
            {category.name}
          </div>
        );
      })}
    </div>
  );
}
